module.exports = __webpack_public_path__ + "img/chevron_double_down_o_icon.faf70ae0.svg";